<template>
  <div class="home">
    <div class="header shadow">
      <div class="container">
        <router-link to="/" class="link">
          <div class="title" @click="chooseHeader(1)">
            <img src="./assets/images/htsslogo.png" alt="" class="img"/>

          </div>
        </router-link>

        <!-- <div class="navigation">
            <input type="checkbox" />
            <span></span>
            <span></span>
            <span></span>
            <ul class="menu">
              <li><a href="#">网站主页</a></li>
              <li><a href="#">产品中心</a></li>
              <li><a href="#">解决方案</a></li>
              <li><a href="#">华特服务</a></li>
              <li><a href="#">典型案例</a></li>
              <li><a href="#">联系我们</a></li>
            </ul>
        </div> -->


<!--        <div class="navigation ">-->
<!--          <span class="btn" id="btn"><img src="./assets/images/更多.png" alt="" class="img"></span>-->
<!--            <ul class="nav active" id="nav">-->
<!--                <li><a href="#">网站主页</a></li>-->
<!--                <li><a href="#">产品中心</a></li>-->
<!--                <li><a href="#">解决方案</a></li>-->
<!--                <li><a href="#">华特服务</a></li>-->
<!--                <li><a href="#">典型案例</a></li>-->
<!--                <li><a href="#">联系我们</a></li>-->
<!--              </ul>-->
<!--        </div>-->



        <!-- <div class="menu" >
          <button onclick="" class="menuMobile">
            <img src="./assets/images/more.png" alt="">
          </button>
        </div> -->



          <div class="menu">
          <el-col>
            <el-dropdown trigger="click">
              <span class="el-dropdown-link">
                  <img src="./assets/images/more.png" alt="" class="imgMenu">
              </span>
              <el-dropdown-menu slot="dropdown" class="menuList">
                <el-dropdown-item >
                  <span @click="goToUrl('/')">网站主页</span>
                </el-dropdown-item>
                <el-dropdown-item >
                    <span @click="goToUrl('/productCenter')">产品中心</span>
                  </el-dropdown-item>
                <el-dropdown-item >
                  <span @click="goToUrl('/solution')">解决方案</span>
                </el-dropdown-item>
                <el-dropdown-item >
                  <span @click="goToUrl('/service')">华特服务</span>
                  </el-dropdown-item>
                <el-dropdown-item >
                  <span @click="goToUrl('/examples')">典型案例</span>
                  </el-dropdown-item>
                <el-dropdown-item >
                  <span @click="goToUrl('/contact')">联系我们</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-col>
        </div>




        <div class="list">
          <router-link to="/" class="link"><span :class="[headerActive == 1 ? 'liActive' : '']"
                                                     @click="chooseHeader(1)">
              主页
            </span></router-link>
          <router-link to="/productCenter" class="link"><span :class="[headerActive == 2 ? 'liActive' : '']"
                                                              @click="chooseHeader(2)">
              产品中心
            </span></router-link>
          <router-link to="/solution" class="link"><span :class="[headerActive == 3 ? 'liActive' : '']"
                                                         @click="chooseHeader(3)">
              解决方案
            </span></router-link>
          <router-link to="/service" class="link"><span :class="[headerActive == 6 ? 'liActive' : '']"
                                                        @click="chooseHeader(6)">
              华特服务
            </span></router-link>
          <router-link to="/examples" class="link"><span :class="[headerActive == 4 ? 'liActive' : '']"
                                                         @click="chooseHeader(4)">
              典型案例
            </span></router-link>
          <router-link to="/contact" class="link"><span :class="[headerActive == 5 ? 'liActive' : '']"
                                                        @click="chooseHeader(5)">
              联系我们
            </span></router-link>
        </div>

<!--        <div class="eng">
          <span v-if="language == 1">English</span>
          <span v-if="language == 2">中文</span>
        </div>-->
      <div></div>
      </div>

    </div>
    <div>

    </div>
    <!-- 路由的容器 -->
    <transition>
      <router-view :key="$route.fullPath" ></router-view>
    </transition>
    <!-- 页脚 -->
    <div class="footer">
      <div class="footerTop">
        <div class="container">
          <div class="footerOne">
            <div class="top">
              <img src="./assets/images/htsslogow.png" alt="" class="img"/>
              <span>华特信息</span>
            </div>
            <div class="center">
              湖北华特信息技术有限公司致力于物联网技术、大数据技术、系统融合技术开发与服务，以融合方式构建教育、医疗、能源、交通等行业的多维度场景应用，系统、解决方案及服务产品。
            </div>
            <div class="badges"></div>
          </div>
          <div class="footerTwo">
            <div class="title">关于我们</div>
            <div class="list">
              <ul>
                <li @click="goToUrl('/')">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;主页
                </li>
                <li @click="gotoNews(6)">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;企业文化
                </li>
                <li @click="goToUrl('/productCenter')">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;产品系列
                </li>
                <li @click="goToUrl('/solution')">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;解决方案
                </li>
                <li @click="goToUrl('/service')">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;华特服务
                </li>
                <li @click="goToUrl('/contact')">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;联系Sales
                </li>
              </ul>
            </div>
          </div>
          <div class="footerThree">
            <div class="title">我们的产品</div>
            <div class="list">
              <ul>
                <li @click="gotoDetail(11)">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;智慧楼宇解决方案
                </li>
                <li @click="gotoDetail(7)">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;一站式智慧运维平台
                </li>
                <li @click="gotoDetail(7)">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;投诉纠纷管理系统
                </li>
                <li @click="gotoDetail(5)">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;资产管理平台
                </li>
                <li @click="gotoDetail(10)">
                  <i class="el-icon-arrow-right"></i>&nbsp;&nbsp;智慧能源运营管理平台
                </li>
              </ul>
            </div>
          </div>
          <div class="footerFour">
            <div class="title">联系我们</div>
            <div class="phone">
              <i class="el-icon-phone-outline"></i>&nbsp;027-85806032
            </div>
            <div class="email">
              <i class="el-icon-message"></i>&nbsp;service@htinfor.com
            </div>
            <div class="QRCode">
              <img src="./assets/images/华特公众号二维码.jpg" alt="" class="QRImg">
            </div>
          </div>
        </div>
      </div>
      <div class="footerMobile">
          <div class="footerMobilePhone">联系电话:027-85806032</div>
          <div class="footerMobileEmil">邮箱:service@htinfor.com</div>
          <div class="footerMobileAddress">地址:湖北省武汉市江汉区新华路296号IFC国际金融中心1213-16室</div>
        </div>
      <div class="footerBottom">
        <div class="text">
          © Copyright 2023 湖北华特信息技术有限公司. All Rights Reserved.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color:#fff;">鄂ICP备19027112号</a>
        </div>
      </div>
    </div>

      <!-- 悬浮 -->
      <div id="wuyousujian-cus-box" style="bottom:80px;">
          <div class="wuyousujian-cus-phone" @click="goToUrl('/lxwm')">
              <a href="javascript:;"><img src="./assets/images/contact1.png"><br />申请试用</a>
          </div>

          <div class="wuyousujian-cus-phone">
              <a href="javascript:;"><img src="./assets/images/contact3.png"><br />联系我们</a>
              <div class="wuyousujian-cus-list-box">
                  <div class="wuyousujian-cus-list">
                      <ul>
                          <li>
                              <a href="tel:13971328095">13971328095</a>
                          </li>
                      </ul>
                  </div>
              </div>
          </div>

          <div class="wuyousujian-cus-erweima">
              <a href="javascript:;"><img src="./assets/images/contact2.png"><br />在线咨询</a>
              <div class="wuyousujian-cus-list-box wuyousujian-erweima">
                  <div class="wuyousujian-cus-list"><img src="./assets/images/weixin.png" style="max-width:100%;"></div>
              </div>
          </div>

          <div class="wuyousujian-cus-top">
              <a href="javascript:scroll(0,0);"><img src="./assets/images/contact4.png"></a>
          </div>
      </div>

  </div>
</template>

<script>
// window.onload =  function(){
//     var btn =document.getElementById("btn");
//     var nav =document.getElementById("nav");
//     btn.click = function(){
//       if(nav.className == "nav"){
//           nav.className = "nav active"
//       }else{
//         nav.className = "nav"
//       }
//   }
// }
export default {
  name: "Home",
  data() {
    return {
      headerActive: 1,
      componentShow: 1,
      language: 1,
    };
  },
    mounted() {
        this.getdata();
    },
  methods: {
      getdata() {
          let self = this
          var url = "index";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              console.log(res);
          })
      },
    chooseHeader(val) {
      this.headerActive = val;
      this.componentShow = val;
    },
    showProductDetail(val) {
      this.componentShow = val;
    },
    handleClick() {
      alert('button click');
    },

    gotoDetail(val) {
      this.$router.push(`/productCenter/detail/${val}`);
    },
    gotoDisplay(val) {
      this.$router.push(`/display/detail/${val}`);
    },
      gotoNews(val) {
          this.$router.push(`/news/detail/${val}`);
      },
    goToUrl(val) {
      this.$router.push(val);
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        let route = to.path;
        if (route == "/") {
          this.headerActive = 1;
        } else if (route == "/productCenter") {
          this.headerActive = 2;
        } else if (route == "/solution") {
          this.headerActive = 3;
        } else if (route == "/examples") {
          this.headerActive = 4;
        } else if (route == "/contact") {
          this.headerActive = 5;
        } else if (route == "/service") {
          this.headerActive = 6;
        } else if (
            route.length > 10 &&
            route.slice(0, 12) == "/service/det"
        ) {
          this.headerActive = 6;
        } else if (route == "/display/detail/2") {
          this.headerActive = 4;
        } else if (route == "/display/detail/3") {
          this.headerActive = 4;
        } else if (
            route.length > 14 &&
            route.slice(0, 18) == "/productCenter/det"
        ) {
          this.headerActive = 2;
        } else {
          this.headerActive = 1;
        }
      },
    },
  },
};

</script>
<style lang="scss" scoped>

.home {
  width: 192rem;
  //当有组件切换动画效果的一瞬间，页面的宽度会变为正常宽度的两倍，此时，需隐藏超出屏幕的区域
  overflow: hidden;

  .header {
    width: 100%;
    height: 7.6rem;
    line-height: 7.6rem;
    background-color: #fff;
    z-index: 999;

    .container {
      width: 172rem;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .menu{
        display: none;
      }
      .link {
        text-decoration: none;
      }
      .navigation{
        display: none;
      }

      .title {
        width: 60rem;
        cursor: pointer;
        display: flex;

        .img {
          width: 12rem;
          height: 5.2rem;
          display: inline-block;
          margin-top: 1rem;
          padding-left: 6rem;
        }

        span {
          color: #4778e0;
          display: inline-block;
          font-size: 3.5rem;
          font-weight: 600;
          margin-left: 1rem;
        }
      }

      .list {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        width: 100rem;

        span {
          display: inline-block;
          margin: 0;
          padding: 0;
          color: rgba(0, 0, 0, 0.55);
          font-size: 1.8rem;
          font-weight: 800;
          padding: 0 1.5rem;
          margin: 0 3rem;
          height: 4rem;
          line-height: 4rem;
          border-radius: 2rem;
          cursor: pointer;

          .link {
            text-decoration: none;
          }
        }

        span:hover {
          color: #fff !important;
          background-color: #3d8bed;
        }

        .liActive {
          color: #fff;
          background-color: #3d8bed;
        }
      }

      .eng {
        display: inline-block;
        color: #ac7c27;
        font-size: 1.4rem;
        line-height: 8rem;
        cursor: pointer;
        margin-left: 6rem;
      }
    }
  }

  .footer {
    z-index: 999;

    .footerTop {
      width: 100%;
      height: 26rem;
      background-color: #3d8bed;
      color: #fff;

      .container {
        width: 128rem;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;

        .footerOne {
          width: 46rem;
          padding-top: 4rem;

          .top {
            text-align: left;
            padding-bottom: 2rem;

            .img {
              width: 4.2rem;
              height: 2.6rem;
              display: inline-block;
            }

            span {
              font-size: 2.2rem;
              font-weight: 500;
              margin-left: 1rem;
            }
          }

          .center {
            width: 26rem;
            text-align: left;
            font-size: 1.5rem;
            line-height: 1.6;
          }
        }

        .footerTwo {
          width: 28rem;
          padding-top: 4rem;

          .title {
            padding-bottom: 2rem;
            font-size: 2.2rem;
            font-weight: 300;
            text-align: left;
          }

          .list {
            ul {
              padding: 0;
              margin: 0;

              li {
                list-style-type: none;
                padding: 0;
                margin: 0;
                text-align: left;
                font-size: 1.5rem;
                height: 3rem;
                line-height: 3rem;
                transition: all 0.5s linear;
              }

              li:hover {
                transition: 0.5s;
                color: rgba(255, 255, 255, 0.55);
                cursor: pointer;
              }
            }
          }
        }

        .footerThree {
          width: 32rem;
          padding-top: 4rem;

          .title {
            padding-bottom: 2rem;
            font-size: 2.2rem;
            font-weight: 300;
            text-align: left;
          }

          .list {
            ul {
              padding: 0;
              margin: 0;

              li {
                list-style-type: none;
                padding: 0;
                margin: 0;
                text-align: left;
                font-size: 1.5rem;
                height: 3rem;
                line-height: 3rem;
                transition: all 0.5s linear;
              }

              li:hover {
                transition: 0.5s;
                color: rgba(255, 255, 255, 0.55);
                cursor: pointer;
              }
            }
          }
        }

        .footerFour {
          width: 23rem;
          padding-top: 4rem;

          .title {
            padding-bottom: 2rem;
            font-size: 2.2rem;
            font-weight: 300;
            text-align: left;
          }

          .phone {
            text-align: left;
            font-size: 1.4rem;
            height: 3rem;
            line-height: 3rem;
          }

          .email {
            text-align: left;
            font-size: 1.4rem;
            height: 3rem;
            line-height: 3rem;
          }

          .QRCode {
            height: 3rem;
          }

          .QRImg {
            margin-left: 2rem;
            height: 8rem;
            width: 8rem;
          }
        }
      }
    }

    .footerMobile{
        display: none;
    }

    .footerBottom {
      width: 100%;
      height: 10rem;
      background-color: #3d8bed;
      line-height: 10rem;

      .text {
        margin: 0 auto;
        width: 128rem;
        color: #fff;
        font-size: 1.6rem;
        text-align: center;
      }
      a{
        text-decoration:none;
      }

    }
  }

  //#wuyousujian-cus-box {display:none;}
    #wuyousujian-cus-box img{border:none;}
    #wuyousujian-cus-box div,#wuyousujian-cus-box a,#wuyousujian-cus-box ul,#wuyousujian-cus-box li{box-sizing:content-box;-webkit-box-sizing:content-box;-ms-box-sizing:content-box;-moz-box-sizing:content-box;}
    #wuyousujian-cus-box{position: fixed; right: 0rem; bottom:20rem; z-index: 9999;}
    #wuyousujian-cus-box a{text-decoration: none; color: #333; font-family: "Microsoft Yahei";}
    #wuyousujian-cus-box > div{position: relative; color: #fff;}
    #wuyousujian-cus-box > div > a{ display: block; background-color: #5f9def; width: 6rem; height: 6rem; margin-top: 0.5rem; text-align: center;  font-size: 1.2rem; color: #333;transition: all 0.6s; -webkit-transition: all 0.6s;-ms-transition: all 0.6s;-moz-transition: all 0.6s; color: #fff;}
    #wuyousujian-cus-box > div > a > img{text-align: center; max-width: 2.5rem; margin: 1rem auto;}
    #wuyousujian-cus-box .wuyousujian-cus-list-box{position: absolute; width: 110px; left: -160px; padding:0px; box-sizing:content-box;-webkit-box-sizing:content-box;-ms-box-sizing:content-box;-moz-box-sizing:content-box; top:0; -webkit-transition: all 0.6s; -webkit-transform:scale(0); opacity: 0; background-color: transparent;}
    #wuyousujian-cus-box .wuyousujian-cus-list-box.wuyousujian-erweima{position:absolute;width:220px;left:-170px;padding:0px;box-sizing:content-box; top:-80px;-moz-box-sizing:content-box; -webkit-box-sizing:content-box; -ms-box-sizing:content-box;  -webkit-transition: all 0.6s;-moz-transition: all 0.6s;-ms-transition: all 0.6s;transition: all 0.6s; -webkit-transform:scale(0);-moz-transform:scale(0);-ms-transform:scale(0);transform:scale(0); opacity: 0;}
    #wuyousujian-cus-box  .wuyousujian-cus-list{ width: 13rem; padding:5px 10px; background-color: #fff;box-shadow: 0px 0px 10px rgba(0,0,0,0.3); border-radius: 5px; }
    #wuyousujian-cus-box  .wuyousujian-cus-list img{vertical-align: middle;}
    #wuyousujian-cus-box .wuyousujian-cus-list-box.wuyousujian-erweima .wuyousujian-cus-list{width:139px;height:139px;padding:10px;background-color: #fff;box-shadow:0px 0px 10px rgba(0,0,0,0.3);border-radius:5px;}
    #wuyousujian-cus-box .wuyousujian-cus-list-box.wuyousujian-erweima .wuyousujian-cus-list:after{top:95px;}
    .wuyousujian-cus-erweima a,.wuyousujian-cus-phone a{line-height: 0.7rem;}
    #wuyousujian-cus-box .wuyousujian-cus-list ul{list-style:none;margin:0;padding:0;background-color:transparent;}
    #wuyousujian-cus-box .wuyousujian-cus-list ul li{margin:10px 0;padding:0;}
    .wuyousujian-cus-list-box .wuyousujian-cus-list ul li a{font-size:2rem;}
    #wuyousujian-cus-box .wuyousujian-cus-list ul li p{font-size:20rem;color:#333;padding:0;margin:0;}
    .wuyousujian-cus-top a{line-height: 8rem;}

    #wuyousujian-cus-box > div:hover .wuyousujian-cus-list-box{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);transform:scale(1); opacity: 1;}
}

@media screen and (max-width: 750px) {
  .home {
    text-decoration: none;
    ul{
      list-style: none;
    }
  //当有组件切换动画效果的一瞬间，页面的宽度会变为正常宽度的两倍，此时，需隐藏超出屏幕的区域
  .header {
    // display: none;
    width: 100%;
    height: 24rem;
    line-height: 7.6rem;
    background-color: #fff;
    z-index: 999;


    .container {
      width: 172rem;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .link {
        text-decoration: none;
      }
      // .navigation{
      //   display: flex;
      //   flex-direction: column;
      //   position: relative;
      //   top:5rem;
      //   left: 8rem;
      //   input{
      //     position: absolute;
      //     width: 14rem;
      //     height: 11.2rem;
      //     // cursor: pointer;
      //     z-index: 2;
      //     opacity: 0;
      //   }

      //   span{
      //     width: 15rem;
      //     height: 1.5rem;
      //     background-color: #3d8bed;
      //     position: relative;
      //     margin-top: 3rem;
      //     transform-origin:5px 0 ;
      //     transition: transfrom 0.5s cubic-bezier(0.77,0.20.05,1.0),opacity 0.55s ease;;
      //   }
      //   input:checked~span{
      //     opacity: 1;
      //     transform: rotate(45deg) translate(-5rem, -9rem);

      //   }
      //   input:checked~span:nth-last-child(3){
      //       opacity: 0;
      //       transform: rotate(0deg) scale(0.2,0.2);
      //   }

      //   input:checked~span:nth-last-child(2){
      //       // opacity: 0;
      //       transform: rotate(-45deg) translate(0,2rem);
      //   }
      //   .menu{
      //     width: 280px;
      //     height: 670px;
      //     position: absolute;
      //     box-sizing: border-box;
      //     background-color: #f5f6fa;
      //     padding: 50px;
      //     padding-top: 24rem;
      //   }




      //   // .btn{
      //   //   .img{
      //   //     height: 12.875rem;
      //   //     width: 12.875rem;
      //   //     margin-top: 6rem;
      //   //     margin-left: 10rem;
      //   //   }

      //   // }
      //   // .nav{
      //   //     width: 100%;
      //   //     background-color: #409EFF;
      //   //     position: absolute;
      //   //     left: 0;
      //   //     top: 22.75rem;
      //   //     z-index: 999;
      //   //     overflow: hidden;
      //   //     height: 0;
      //   //     li{
      //   //       border:0;
      //   //       height: 15.5rem;
      //   //       line-height: 15.5rem;
      //   //       line-height: 40px;
      //   //       padding: 0 .625rem;
      //   //       list-style: none;
      //   //       border-bottom: 0.625rem solid #fff;
      //   //       margin-left: -7rem;

      //   //       a{
      //   //         text-decoration:none;
      //   //         color: white;
      //   //         font-size: 7rem;
      //   //       }
      //   //     }
      //   //     li:last-child{
      //   //       border-bottom: 0;
      //   //     }
      //   //   }
      //   //   .nav.active{
      //   //     height: 94.5rem;
      //   //   }
      // }

      .title {
        width: 150rem;
        cursor: pointer;
        display: flex;

        .img {
          width: 27rem;
          height: 11.7rem;
          display: inline-block;
          margin-top: 6rem;
          padding-left: 6rem;
        }



        span {
          color: #4778e0;
          display: inline-block;
          font-size: 3.5rem;
          font-weight: 600;
          margin-left: 1rem;
        }
      }

      .menu{
        line-height: 30px;
        text-align: right;
        position: relative;
       display: inline-block;
       color: #000;
       .popper__arrow{
        display: none !important;
       }
       .menuList{
        top:18rem  !important;
       }
       .el-dropdown-link {
          cursor: pointer;
          color: #409EFF;
        }

        .imgMenu {
          font-size: 12px;
          height: 15rem;
          margin-top: 5rem;
        }
        .el-dropdown-menu{
          .el-popper[x-placement^=bottom]{
            margin-top: 0;
          }
        }

      }



      .list {
        display: none;
      }

      .eng {
        display: none;
        color: #ac7c27;
        font-size: 1.4rem;
        line-height: 8rem;
        cursor: pointer;
        margin-left: 80rem;
      }
    }

  }


  .shadow {
    box-shadow: rgba(0, 0, 0, 0.15) 0.5rem 0.5rem 2rem !important;
  }

  .footer {
    z-index: 999;

    .footerTop {
      display: none;
    }
    .footerMobile {
      padding-top: 10rem;
      display:block;
      width: 100%;
      line-height: 10rem;
      background-color: #3d8bed;
      color: #fff;
      font-size: 6.5rem;
      //font-weight: 100;
      text-align: center;
    }

    .footerBottom {
      width: 100%;
      height: 30rem;
      background-color: #3d8bed;
      line-height: 10rem;
      a{
        text-decoration:none
      }

    }
  }

}

    //#wuyousujian-cus-box {display:block !important;}
    #wuyousujian-cus-box img{border:none;}
    #wuyousujian-cus-box div,#wuyousujian-cus-box a,#wuyousujian-cus-box ul,#wuyousujian-cus-box li{box-sizing:content-box;-webkit-box-sizing:content-box;-ms-box-sizing:content-box;-moz-box-sizing:content-box;}
    #wuyousujian-cus-box{position: fixed; right: 8rem; bottom:20rem; z-index: 9999;}
    #wuyousujian-cus-box a{text-decoration: none; color: #333; font-size: 12px; font-family: "Microsoft Yahei";}
    #wuyousujian-cus-box > div{position: relative; color: #fff;}
    #wuyousujian-cus-box > div > a{ display: block; background-color: #5f9def; width: 28rem !important; height: 28rem !important; margin-top: 3rem !important; text-align: center; line-height: 1rem; font-size: 6rem; color: #333;transition: all 0.6s; -webkit-transition: all 0.6s;-ms-transition: all 0.6s;-moz-transition: all 0.6s; color: #fff;}
    #wuyousujian-cus-box > div > a > img{text-align: center; max-width: 10rem !important; margin: 5rem auto !important;}
    #wuyousujian-cus-box .wuyousujian-cus-list-box{position: absolute; width: 110px; left: -115px; padding:0px; box-sizing:content-box;-webkit-box-sizing:content-box;-ms-box-sizing:content-box;-moz-box-sizing:content-box; top:-15px; -webkit-transition: all 0.6s; -webkit-transform:scale(0); opacity: 0; background-color: transparent;}
    #wuyousujian-cus-box .wuyousujian-cus-list-box.wuyousujian-erweima{position:absolute;width:220px;left:-170px;padding:0px;box-sizing:content-box; top:-80px;-moz-box-sizing:content-box; -webkit-box-sizing:content-box; -ms-box-sizing:content-box;  -webkit-transition: all 0.6s;-moz-transition: all 0.6s;-ms-transition: all 0.6s;transition: all 0.6s; -webkit-transform:scale(0);-moz-transform:scale(0);-ms-transform:scale(0);transform:scale(0); opacity: 0;}
    #wuyousujian-cus-box  .wuyousujian-cus-list{ width: 90px; padding:1px 10px; background-color: #fff;box-shadow: 0px 0px 10px rgba(0,0,0,0.3); border-radius: 5px; }
    #wuyousujian-cus-box  .wuyousujian-cus-list img{vertical-align: middle;}
    #wuyousujian-cus-box .wuyousujian-cus-list-box.wuyousujian-erweima .wuyousujian-cus-list{width:139px;height:139px;padding:10px;background-color: #fff;box-shadow:0px 0px 10px rgba(0,0,0,0.3);border-radius:5px;}
    /*#wuyousujian-cus-box .wuyousujian-cus-list:after{content: ''; display: block; width: 10px; height: 10px; background-color: #fff; position: absolute; top: 30px; right: -5px; -webkit-transform:rotate(45deg); -moz-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);}*/
    #wuyousujian-cus-box .wuyousujian-cus-list-box.wuyousujian-erweima .wuyousujian-cus-list:after{top:95px;}
    #wuyousujian-cus-box .wuyousujian-cus-list ul{list-style:none;margin:0;padding:0;background-color:transparent;}
    #wuyousujian-cus-box .wuyousujian-cus-list ul li{margin:10px 0;padding:0;}
    #wuyousujian-cus-box .wuyousujian-cus-list ul li p{font-size:12px;color:#333;padding:0;margin:0;}
    .wuyousujian-cus-top a{line-height: 35rem !important;}

    #wuyousujian-cus-box > div:hover .wuyousujian-cus-list-box{-webkit-transform:scale(1);-moz-transform:scale(1);-ms-transform:scale(1);transform:scale(1); opacity: 1;}
}


//动画效果相关的类样式
.v-enter {
  opacity: 0;
  //让即将进入的页面向右偏移100%
  transform: translateX(100%);
}

.v-leave-to {
  opacity: 0;
  //让即将进入的页面向右偏移100%
  transform: translateX(-100%);
  position: absolute;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.5s ease;
}
</style>
<style lang="scss">
body{
  font-family: "思源黑体N","思源黑体M" ,"思源黑体";
}
.home {
  .el-carousel__item img {
    width: 100%;
    height: 100%;
  }

  .el-carousel--horizontal {
    overflow-x: hidden;
    width: 100%;
  }

  .el-carousel__container {
    height: 82rem;
  }

  .el-tabs__nav-wrap::after {
    background-color: #fff;
  }
}
</style>
